import { GALLERY } from "@/data/site";
import { useLang } from "@/lib/i18n";

export default function Gallery() {
  const { t } = useLang();
  return (
    <section data-testid="gallery" className="section-padding bg-white">
      <div className="container-max">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-brand-yellow-dark">
              {t.home.galleryEyebrow}
            </p>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mt-2 max-w-2xl leading-tight">
              {t.home.galleryTitle}
            </h2>
            <p className="text-slate-600 mt-3 max-w-2xl">{t.home.gallerySub}</p>
          </div>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {GALLERY.map((g, i) => (
            <figure
              key={i}
              data-testid={`gallery-item-${i}`}
              className="group relative overflow-hidden rounded-2xl border border-slate-200 bg-white aspect-square shadow-sm hover:shadow-xl transition-shadow"
            >
              <img
                src={g.url}
                alt={g.alt}
                loading="lazy"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-brand-navy-dark/95 via-brand-navy-dark/40 to-transparent p-4 opacity-0 group-hover:opacity-100 transition-opacity">
                <p className="text-xs font-bold uppercase tracking-wider text-brand-yellow">{t.home.galleryEyebrow}</p>
                <p className="text-sm text-white font-medium mt-0.5">{g.caption}</p>
              </div>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
